class AiDebugService {
  constructor() {
    this.debugInfo = [];
    this.debugMode = false;
  }

  // Enable/disable debug mode
  setDebugMode(enabled) {
    this.debugMode = enabled;
    localStorage.setItem('bullbearly-ai-debug-mode', enabled.toString());
  }

  // Get current debug mode
  isDebugEnabled() {
    return localStorage.getItem('bullbearly-ai-debug-mode') === 'true';
  }

  // Log AI request/response for debugging
  logAiRequest(type, model, prompt, response, error = null) {
    if (!this.isDebugEnabled()) {
      console.log('Debug logging disabled, skipping log entry');
      return;
    }

    console.log('Logging AI request:', { type, model, prompt: prompt?.substring(0, 100) + '...' });

    const debugEntry = {
      timestamp: new Date().toISOString(),
      type: type, // 'master-prompt', 'custom-prompt', etc.
      model: model,
      prompt: prompt,
      response: response,
      error: error
    };

    this.debugInfo.push(debugEntry);
    
    // Keep only last 100 entries to prevent memory issues
    if (this.debugInfo.length > 100) {
      this.debugInfo = this.debugInfo.slice(-100);
    }

    // Store in localStorage for persistence
    localStorage.setItem('bullbearly-ai-debug-log', JSON.stringify(this.debugInfo));
    
    console.log('Debug entry added, total entries:', this.debugInfo.length);
  }

  // Get debug info
  getDebugInfo() {
    // Load from localStorage if not already loaded
    if (this.debugInfo.length === 0) {
      const stored = localStorage.getItem('bullbearly-ai-debug-log');
      if (stored) {
        try {
          this.debugInfo = JSON.parse(stored);
        } catch (e) {
          console.error('Error parsing debug log from localStorage:', e);
          this.debugInfo = [];
        }
      }
    }
    return this.debugInfo;
  }

  // Clear debug info
  clearDebugInfo() {
    this.debugInfo = [];
    localStorage.removeItem('bullbearly-ai-debug-log');
  }

  // Get model configuration
  getMasterPromptModel() {
    return localStorage.getItem('bullbearly-master-prompt-model') || 'gpt-4o-mini';
  }

  getCustomPromptModel() {
    return localStorage.getItem('bullbearly-custom-prompt-model') || 'gpt-4o-mini';
  }

  getAssistantId() {
    return localStorage.getItem('bullbearly-assistant-id') || 'asst_wdJ89zOBA2Tfo6R4KC9fUXcJ';
  }

  // Update model configuration
  setMasterPromptModel(model) {
    localStorage.setItem('bullbearly-master-prompt-model', model);
  }

  setCustomPromptModel(model) {
    localStorage.setItem('bullbearly-custom-prompt-model', model);
  }

  setAssistantId(assistantId) {
    localStorage.setItem('bullbearly-assistant-id', assistantId);
  }
}

// Create and export a singleton instance
const aiDebugService = new AiDebugService();
export default aiDebugService;
